import { useEffect, useRef, useState } from 'react';
/** Локальное превью файла не подменяет ready upload: его UUID выдаёт только сервер после проверки. */
export function useCircleLocalMedia() {
  const current = useRef<string | null>(null);
  const [preview, setPreview] = useState<{ url: string; mime: string } | null>(null);
  useEffect(
    () => () => {
      if (current.current) URL.revokeObjectURL(current.current);
    },
    [],
  );
  const select = (file: File | null) => {
    if (current.current) URL.revokeObjectURL(current.current);
    current.current = null;
    if (file && /^(image\/(jpeg|png|webp)|video\/mp4)$/.test(file.type)) {
      current.current = URL.createObjectURL(file);
      setPreview({ url: current.current, mime: file.type });
    } else setPreview(null);
  };
  return { preview, select };
}
